import apiConfig from "../config/apiConfig";
import { fetchForeignResource } from "../apis/resources";
import { fetchEnum } from "../apis/enum";
import { apiFetch } from "../apis/apiFetch";



export const examdetailsService = {
  // ✅ CREATE / UPDATE
  async create(data: any) {
    const res = await apiFetch(apiConfig.getResourceUrl("applications"), {
      method: "POST",
      body: data.params,
    });

    const resJson = await res.json();
    console.log("exam details response", resJson);

    return resJson;
  },

  // ✅ GET ALL DATA (optional use)
  async getData() {
    const response = await apiFetch(apiConfig.getResourceUrl("applications"), {
      method: "GET",
    });

    if (!response.ok) {
      throw new Error("Error: " + response.status);
    }

    const data = await response.json();
    return data.resource || [];
  },

  // ✅ METADATA
  async getMetadata(): Promise<any> {
    const metadataUrl =
      apiConfig.getResourceMetaDataUrl("Examdetails");

    const res = await fetch(metadataUrl);

    if (!res.ok) throw new Error("Metadata fetch failed");

    return res.json();
  },

  // ✅ FOREIGN KEYS
  async getForeignResource(name: string): Promise<any[]> {
    const data = await fetchForeignResource(name);
    return data;
  },

  // ✅ ENUMS
  async getEnum(name: string): Promise<any[]> {
    const data = await fetchEnum(name);
    return data;
  },
};